import * as yup from "yup";
import sharedValidationSchema from "../../shared/PersonalInformation/validation";

/**
 * Validation schema for producer-specific personal information form fields.
 * Extends the shared personal information validation schema with additional fields
 * required for producer onboarding flow.
 * 
 * @type {yup.ObjectSchema}
 * @description This schema validates:
 * - isLicensedProducer: Boolean field indicating if the user is a licensed producer
 * - producerNPN: National Producer Number (5-9 characters) required when isLicensedProducer is true
 * - parentBranchSob: Optional string field for parent branch SOB information
 */
const validationSchema = sharedValidationSchema.concat(
    yup.object({
        isLicensedProducer: yup.bool().required("Please select if you are a licensed producer."),
        producerNPN: yup.string()
            .test("length-check", "Please enter a valid NPN.", npn => npn == null || npn.length === 0 || (npn?.length >= 5 && npn?.length <= 9))
            .when('isLicensedProducer', {
                is: (value) => value === true,
                then: (schema) => schema.required("Please enter your NPN."),
                otherwise: (schema) => schema.nullable().optional()
            }),
        parentBranchSob: yup.string().nullable().optional()
    })
);

export default validationSchema;